(
    function (skyward, $)
    {
        "use strict";

        skyward.LDAP = skyward.LDAP || {};

        var ldapDefaultFilter = '(&(objectclass=user)(|(cn=%s)(sAMAccountName=%s)(userPrincipalName=%s)))';

        function init(selector)
        {
            $(selector).find('.ldapSearchBaseDN').each(function ()
            {
                var element = $(this);
                element.change(function ()
                {
                    if (element.val() != '')
                    {
                        var filter = $(selector).find('.ldapSearchFilter');

                        if (filter && filter.val() == '')
                        {
                            filter.val(ldapDefaultFilter);
                        }
                    }
                });
            });

            $(selector).find('.ldapGroupBaseDN').each(function ()
            {
                var element = $(this);
                element.change(function ()
                {
                    if (element.val() != '')
                    {
                        var ldapGroupBaseDN = $(selector).find('.ldapGroupBaseDN');

                        if (ldapGroupBaseDN && ldapGroupBaseDN.val() == '')
                        {
                            ldapGroupBaseDN.val(ldapDefaultFilter);
                        }

                        var ldapGroupFilter = $(selector).find('.ldapGroupFilter');

                        if (ldapGroupFilter && ldapGroupFilter.val() == '')
                        {
                            ldapGroupFilter.val("(objectClass=group)");
                        }

                        var ldapGroupMemberFilter = $(selector).find('.ldapGroupMemberFilter');

                        if (ldapGroupMemberFilter && ldapGroupMemberFilter.val() == '')
                        {
                            ldapGroupMemberFilter.val("(objectClass=user)");
                        }

                        var ldapUsernameAttribute = $(selector).find('.ldapUsernameAttribute');

                        if (ldapUsernameAttribute && ldapUsernameAttribute.val() == '')
                        {
                            ldapUsernameAttribute.val("sAMAccountName");
                        }
                    }
                });
            });

            $(selector).find('.testLDAPProviderResult').on("change", function ()
            {
                $(this).scrollTop(0);
            });

            $(selector).find('.testPassword').on("keypress", function (e)
            {
                if (e.keyCode == 13)
                {
                    $(selector).find('.testLDAPProviderValidateLDAPUserButton').trigger("click");
                }
            });

            $(selector).find('.protocolCode').on("change", function ()
            {
                var port = $(selector).find('.port');

                switch ($(this).val())
                {
                    case "T":
                    case "S":
                    case "K":
                        if (port.val() == '' || port.val() == '636')
                        {
                            port.val("389");
                        }
                        break;
                    case "L":
                        if (port.val() == '' || port.val() == '389')
                        {
                            port.val("636");
                        }
                        break;
                }
            });

        }

        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);